export const DEFAULT_OTP_LENGTH = 6

/** Apply pasted text into OTP digit slots starting at `startIndex` (non-digits ignored). */
export function applyOtpPaste(
  current: string[],
  pastedText: string,
  startIndex: number,
): { next: string[]; focusIndex: number } {
  const digits = pastedText.replace(/\D/g, '')
  if (digits.length === 0) {
    return { next: current, focusIndex: startIndex }
  }

  const next = [...current]
  const room = Math.max(0, next.length - startIndex)
  const toApply = digits.slice(0, room)
  for (let i = 0; i < toApply.length; i++) {
    next[startIndex + i] = toApply[i]!
  }

  const focusIndex = Math.min(startIndex + toApply.length, next.length - 1)
  return { next, focusIndex }
}
